import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> Configuration Review</li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>Configuration Review</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  Misconfigurations are one of the leading causes of cyber
                  breaches worldwide. From firewalls and routers to operating
                  systems, databases, and cloud environments, insecure
                  configurations can open the door to unauthorized access, data
                  theft, and business disruption. Our Configuration Review
                  Services provide a comprehensive assessment of your IT
                  infrastructure configurations, ensuring that every device,
                  system, and application is hardened against evolving cyber
                  threats.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-arrows-down-to-people"></i>
                  </div>
                  <div className="service-card-content">
                    <p>
                     80%+ of breaches are caused by misconfigurations, not missing patches.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-database"></i>
                  </div>
                  <div className="service-card-content">
                    <p>
                      Networking devices, OS, and databases are prime targets for attackers.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-shield-halved"></i>
                  </div>
                  <div className="service-card-content">
                    <p>
                     Misconfigured systems can lead to downtime, compliance failures, and financial losses.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-table"></i>
                  </div>
                  <div className="service-card-content">
                    <p>
                     Regulatory frameworks like ISO 27001, PCI DSS, HIPAA, GDPR, and SOC 2 mandate secure configuration management
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-business-time"></i>
                  </div>
                  <div className="service-card-content">
                    <p>
                     Attackers often exploit default credentials, open ports, weak encryption, and improper access controls—all of which can be detected in a thorough review.
                    </p>
                  </div>
                </div>
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "methodology" ? " active" : ""}`}
                        onClick={() => setActiveTab("methodology")}
                      >
                        Methodology
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "keybenefits" ? " active" : ""}`}
                        onClick={() => setActiveTab("keybenefits")}
                      >
                        Key Benefits
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "deliverables" ? " active" : ""}`}
                        onClick={() => setActiveTab("deliverables")}
                      >
                        Deliverables
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content" id="ex2-content">
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      id="methodology"
                      role="tabpanel"
                    >
                      <p>
                       Our structured methodology covers all layers of your IT environment:
                      </p>
                      <ul>
                        <li>
                          <b>Scope Identification  :-</b> Networking devices, OS, applications, databases, cloud platforms.
                        </li>
                        <li>
                          <b>Baseline Standards  :-</b> Align with CIS Benchmarks, NIST, ISO, vendor best practices.
                        </li>
                        <li>
                          <b>Configuration Collection :-</b> Securely extract configuration files and system settings.
                        </li>
                        <li>
                          <b>Review & Analysis  :-</b> Check authentication, access controls, encryption, patching, logging, and monitoring.
                        </li>
                        <li>
                          <b>Compliance Mapping  :-</b> Compare against ISO 27001, PCI DSS, HIPAA, GDPR, SOC 2.
                        </li>
                        <li>
                          <b>Risk Assessment  :-</b>
                          Identify misconfigurations and assign severity levels.
                        </li>
                        <li>
                          <b>Recommendations & Hardening  :-</b>
                         Provide tailored, actionable remediation steps.
                        </li>
                        <li>
                          <b>Revalidation  :-</b> Confirm that remediated systems meet security standards.
                        </li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      id="keybenefits"
                      role="tabpanel"
                    >
                      <ul>
                        <li>
                          Prevent breaches caused by weak or default configurations.
                        </li>
                        <li>
                          Protection of critical assets and industrial
                          operations.
                        </li>
                        <li>
                          Strengthen resilience across network, system, and application layers.
                        </li>
                        <li>
                          Enhance visibility into overlooked security gaps.
                        </li>
                        <li>
                          Reduce downtime by ensuring optimized and secure configurations.
                        </li>
                        <li>
                          Build trust and confidence with customers and regulators.
                        </li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      id="deliverables"
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>
                          <b>Detailed Configuration Review Report  :-</b> (per device/system).
                        </li>
                        <li>
                          <b>Compliance Gap Analysis  :-</b> mapped to CIS, NIST, ISO, PCI DSS, HIPAA, SOC 2.
                        </li>
                        <li>
                          <b>Risk Register  :-</b> with impact and priority levels.
                        </li>
                        <li>
                          <b>System & Device Hardening Guidelines  :-</b> (step-by-step).
                        </li>
                        <li>
                          <b>Audit-Ready Documentation  :-</b> for certifications and regulatory audits.
                        </li>
                        <li>
                          <b>Revalidation Report :-</b> post-remediation.
                        </li>
                        <li>
                          <b>Executive Summary + Technical Report :-</b> tailored for leadership and IT teams.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li>
                      <b>End-to-End Expertise :-</b> Networking devices, OS (Windows/Linux), Databases (Oracle, MySQL, MS SQL), Applications, Virtualization, and Cloud (AWS, Azure, GCP).
                    </li>
                    <li>
                      <b>Best-in-Class Standards :-</b> CIS, NIST, ISO 27001, PCI DSS, HIPAA, GDPR, SOC 2.
                    </li>
                    <li>
                      <b>Hybrid Approach :-</b> Automated scanning + manual expert review for accuracy.
                    </li>
                    <li>
                      <b>Business-Friendly Reports :-</b> Technical details for IT/security teams + executive-level summaries.
                    </li>
                    <li>
                      <b>Vendor-Agnostic :-</b> Proficiency across Cisco, Juniper, Fortinet, Check Point, Microsoft, Red Hat, Oracle, VMware, AWS, Azure, and more.
                    </li>
                    <li>
                      <b>Proactive & Practical :-</b> We don’t just highlight risks—we show you how to fix them.
                    </li>
                  </ul>

                  <p>Key Areas of Review:</p>
                  <ul>
                    <li>
                      <b>Networking Devices   :-</b> Firewalls, routers, switches, load balancers, IDS/IPS, VPN concentrators, WAF.
                    </li>
                    <li>
                      <b>Operating Systems   :-</b> Windows, Linux, Unix systems
                    </li>
                    <li>
                      <b>Databases   :-</b> Oracle, MySQL, PostgreSQL, SQL Server, MongoDB.
                    </li>
                    <li>
                      <b>Applications   :-</b> Web servers (Apache, Nginx, IIS), Email servers, ERP/CRM.
                    </li>
                    <li>
                      <b>Cloud Platforms   :-</b> AWS, Azure, GCP, private cloud.
                    </li>
                    <li>
                      <b>Virtualization & Containers  :-</b> VMware, Hyper-V, Kubernetes, Docker.
                    </li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------*/}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
